"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizableTableHead = exports.ResizableTable = exports.ResizeContext = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_context_1 = require("../../../_util/config-context");
var merge_refs_1 = require("../../../_util/merge-refs");
/**
 * 拖拽 Context 实例
 */
exports.ResizeContext = react_1.createContext({});
exports.ResizeContext.displayName = "Resizable";
function ResizableTable(_a) {
    var table = _a.table, columns = _a.columns, props = tslib_1.__rest(_a, ["table", "columns"]);
    var wrapperRef = react_1.useRef(null);
    var lineRef = react_1.useRef(null);
    var headRef = react_1.useRef(null);
    var _b = tslib_1.__read(react_1.useState(false), 2), isResizing = _b[0], setIsResizing = _b[1];
    var classPrefix = config_context_1.useConfig().classPrefix;
    var resizeContext = {
        wrapperRef: wrapperRef,
        lineRef: lineRef,
        columns: columns,
        classPrefix: classPrefix,
        headRef: headRef,
        isResizing: isResizing,
        setIsResizing: setIsResizing,
        setHeadRef: function (element) {
            headRef.current = element;
        },
    };
    return (react_1.default.createElement(exports.ResizeContext.Provider, { value: resizeContext }, react_1.default.cloneElement(table, tslib_1.__assign(tslib_1.__assign({}, props), { className: classnames_1.default(table.props.className, classPrefix + "-table--resizeable", props.className // eslint-disable-line
        ), children: (react_1.default.createElement("div", { style: { position: "relative", overflow: "auto" }, ref: wrapperRef },
            react_1.default.createElement("div", { ref: lineRef, style: {
                    position: "absolute",
                    top: 0,
                    left: "0px",
                    height: "100%",
                    backgroundColor: "#e7eaef",
                    width: "1px",
                    zIndex: 500,
                    display: "none",
                } }),
            table.props.children)) }))));
}
exports.ResizableTable = ResizableTable;
exports.ResizableTableHead = react_1.forwardRef(function (_a, ref) {
    var head = _a.head, props = tslib_1.__rest(_a, ["head"]);
    var setHeadRef = react_1.useContext(exports.ResizeContext).setHeadRef;
    return react_1.default.cloneElement(head, tslib_1.__assign(tslib_1.__assign({}, props), { ref: merge_refs_1.mergeRefs(head.ref, ref, setHeadRef) }));
});
ResizableTable.displayName = "ResizableTable";
//# sourceMappingURL=ResizableTable.js.map